import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ArrowIcon } from "../../assets/Icons";
import NoDataFound from "../../common/NoDataFound";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";

const active = true;


const WorkflowList = ({ workflows = [], taskManageVersion }) => {
  const history = useHistory();
  const handleNavigation = (id) => {
    history.push(`${taskManageVersion}`);
  };

  return (
    <>
      <HeaderMobileSearch showFilterBtn={true} backBtn={true} searchAnimated={false} searchMode={false} />
      <h4 className="pb-2 pt-3 px-3">Assigned workflow</h4>
      <div className="work-list">
        {workflows.length === 0 ? (
          <NoDataFound headText="No data found" />
        ) : (
          workflows.map((workflow, index) => (
            <div key={workflow.id || index} className="workcard" onClick={() => taskManageVersion(workflow)}>
              <div className="left">
                <div className="work-detail">
                  <h6 className="work-heading">{workflow.title || "Untitled"}</h6>
                  <span>v{workflow.versionData?.[0]?.version || "1.0"}</span>
                </div>
                <div className="description">{workflow?.sopData?.sop_type_name || "N/A"}</div>
                <p className="work-content">{workflow.description || "No description available"}</p>
              </div>
              <div className="right">
                {workflow.status === 1 ? (
                  <div className="live-banner">Live</div>
                ) : (
                  <div className="live-banner inactive-banner">Inactive</div>
                )}
                <ArrowIcon />
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default WorkflowList;
